export default __webpack_public_path__ + "static/media/hexagon-inner-13.5e8dbceb.svg";